import { useFocusEffect, useNavigation } from '@react-navigation/native';
import { useCallback } from 'react';
import { useHandleNavigationMachinesHeader } from './useHandleNavigationMachineHeader';
import { SMART_FACTORY } from '@v2/pages/common/constants/base.constants';
import { MachinesScreen } from '@v2/pages/machines/common/enums';
import { useSelector } from 'react-redux';
import { selectSelectedItem } from '@reducers/machines';
import { ALL_MACHINES } from '@helpers';

export const useHandleMachinesScreenTitle = () => {
  const navigation = useNavigation<any>();
  const {
    isMachinesScreen,
    activePerformanceSubScreenName,
    activeScreenNameWithoutMachineMainScreen,
    isNowSubScreen,
    isMachinesEventsScreen
  } = useHandleNavigationMachinesHeader();
  const selectedItem = useSelector(selectSelectedItem);

  useFocusEffect(
    useCallback(() => {
      if (!isMachinesScreen) return;

      let title = '';
      const machinesShortName = selectedItem.id === ALL_MACHINES ? 'All Machines' : selectedItem?.shortName;

      const buildBasicTitle = (screen: string) => `${machinesShortName ? machinesShortName + ' - ' : ''}${screen} - ${SMART_FACTORY}`;

      const buildPerformanceTitle = () =>
        `${machinesShortName ? machinesShortName + ' - ' : ''}${MachinesScreen.PERFORMANCE}${
          activePerformanceSubScreenName ? ' - ' + activePerformanceSubScreenName : ''
        } - ${SMART_FACTORY}`;

      if (
        [MachinesScreen.HISTORY, MachinesScreen.TIMELINE, MachinesScreen.SCHEDULED, MachinesScreen.MAINTENANCE].some((s) =>
          activeScreenNameWithoutMachineMainScreen.includes(s)
        )
      ) {
        title = buildBasicTitle(activeScreenNameWithoutMachineMainScreen);
      }

      if (isMachinesEventsScreen) {
        title = buildBasicTitle(MachinesScreen.EVENTS);
      }

      if (activePerformanceSubScreenName && !isNowSubScreen) {
        title = buildPerformanceTitle();
      }

      if (isNowSubScreen) {
        title = `${machinesShortName ? machinesShortName + ' - ' : ''}${MachinesScreen.LIVE} - ${SMART_FACTORY}`;
      }

      navigation.setOptions({ title });
    }, [selectedItem?.id])
  );
};
